(function() {
  'use strict';

  var STORAGE_KEY = 'nb-scroll-restore';
  var STATE_TTL_MS = 30 * 60 * 1000;

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  function attachClickListeners() {
    var productLinks = document.querySelectorAll('a[href*="/products/"]');
    productLinks.forEach(function(link) {
      if (link.dataset.nbScrollBound) return;
      link.dataset.nbScrollBound = 'true';

      link.addEventListener('click', function() {
        var card = link.closest('[data-product-handle]')
                || link.closest('.product-card')
                || link.closest('.nb-product-card')
                || link.closest('.nb-ca-card')
                || link.closest('[class*="product-card"]');

        var handle = null;
        if (card && card.hasAttribute('data-product-handle')) {
          handle = card.getAttribute('data-product-handle');
        } else {
          var match = link.href.match(/\/products\/([^/?#]+)/);
          if (match) handle = match[1];
        }

        var state = {
          url: window.location.href,
          handle: handle,
          scrollY: window.scrollY,
          timestamp: Date.now()
        };

        try {
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
        } catch (err) {}
      });
    });
  }

  function restoreScroll() {
    var state;
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      state = JSON.parse(raw);
    } catch (err) {
      return;
    }

    if (!state || state.url !== window.location.href) return;

    if (Date.now() - state.timestamp > STATE_TTL_MS) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }

    var attempts = 0;
    var maxAttempts = 20;

    function tryRestore() {
      attempts++;

      if (state.handle) {
        var card = document.querySelector('[data-product-handle="' + state.handle + '"]');
        if (card) {
          if (card.classList && !card.classList.contains('is-revealed')) {
            card.classList.add('is-revealed');
          }
          var rect = card.getBoundingClientRect();
          var absoluteTop = rect.top + window.scrollY;
          var viewportCenter = window.innerHeight / 2;
          var cardCenter = rect.height / 2;
          window.scrollTo({
            top: absoluteTop - viewportCenter + cardCenter,
            behavior: 'instant'
          });
          sessionStorage.removeItem(STORAGE_KEY);
          return;
        }
      }

      if (attempts >= maxAttempts) {
        if (typeof state.scrollY === 'number') {
          window.scrollTo({ top: state.scrollY, behavior: 'instant' });
        }
        sessionStorage.removeItem(STORAGE_KEY);
        return;
      }

      setTimeout(tryRestore, 80);
    }

    tryRestore();
  }

  function init() {
    attachClickListeners();
    restoreScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* BFCache · Safari restored Page aus Memory ohne DOMContentLoaded.
     Wir müssen restore manuell triggern weil scrollRestoration='manual'
     die native Scroll-Wiederherstellung unterdrückt. */
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      restoreScroll();
    }
  });

  document.addEventListener('shopify:section:load', attachClickListeners);
  document.addEventListener('shopify:section:reorder', attachClickListeners);

  /* Re-bind Listener für dynamisch eingefügte Cards (Load More, Collection Sort) */
  var observer = new MutationObserver(attachClickListeners);
  observer.observe(document.body, { childList: true, subtree: true });
})();
